import { useQuery } from '@tanstack/react-query';
import CustomAxios from '../../../utility/customAxios';
import { queryKeys } from '../queryKeys';
import { FormSubmission } from '../../../types/FormSubmission';

const fetchFormSubmission = async (uuid: string | undefined) => {
  if (uuid === undefined) return null;

  const response = await CustomAxios.get<FormSubmission>(`form_submissions/${uuid}`);
  const { data } = response;
  return data;
};

interface UseGetFormSubmissionByIdProps {
  uuid?: string;
  enabled?: boolean;
}

export function useGetFormSubmissionById({ uuid, enabled = true }: UseGetFormSubmissionByIdProps) {
  return useQuery({
    queryKey: [queryKeys.allFormSubmissions, uuid],
    queryFn: () => fetchFormSubmission(uuid),
    enabled,
  });
}
